module.exports = __webpack_public_path__ + "img/Alexandre.36c6afe3.jpeg";